import { createApp, h, ref } from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'

import { faTrashCan, faCheck } from '@fortawesome/pro-solid-svg-icons'
import { faTrashCan as farTrashCan, faCheck as farCheck } from '@fortawesome/pro-regular-svg-icons'

library.add(faTrashCan, farTrashCan, faCheck, farCheck)

import ConfirmationModal from '../../src/components/ConfirmationModal.vue'

export const confirmPlugin = {
  install(mainApp) {
    let showModal = ref(false)

    let content = ref('')
    let modalProps = ref({})
    let confirmButtonProps = ref({})
    let cancelButtonProps = ref({})
    let onConfirm = ref(() => new Promise({}))
    let onCancel = ref(() => {})

    const resetProps = () => {
      showModal.value = false
      content.value = ''
      modalProps.value = {}
      confirmButtonProps.value = {}
      cancelButtonProps.value = {}
      onConfirm.value = () => new Promise({})
      onCancel.value = () => {}
    }

    const confirm = {
      delete: ({ content: contentParam, confirmText: confirmTextParam = 'Yes, Delete', confirmTextIcon: confirmTextIcon = 'fa-trash-can', cancelText: cancelTextParam = 'Cancel',
                 modalProps: modalPropsParam, onConfirm: onConfirmParam, onCancel: onCancelParam = () => {} }) => {
        showModal.value = true
        content.value = contentParam
        onConfirm.value = onConfirmParam
        onCancel.value = onCancelParam
        modalProps.value = modalPropsParam

        confirmButtonProps.value = {
          text: confirmTextParam,
          theme: 'destructive',
          emphasis: 'high',
          icon: confirmTextIcon,
          dataTestid: 'confirm-button',
        }
        cancelButtonProps.value = {
          text: cancelTextParam,
          dataTestid: 'cancel-button',
        }
      },
      update: ({ content: contentParam, confirmText: confirmTextParam = 'Yes, Update', cancelText: cancelTextParam = 'Cancel',
                 confirmIcon: confirmIcon = 'fa-check', modalProps: modalPropsParam, onConfirm: onConfirmParam, onCancel: onCancelParam = () => {} }) => {
        showModal.value = true
        content.value = contentParam
        onConfirm.value = onConfirmParam
        onCancel.value = onCancelParam
        modalProps.value = modalPropsParam

        confirmButtonProps.value = {
          text: confirmTextParam,
          emphasis: 'high',
          icon: confirmIcon,
          dataTestid: 'confirm-button',
        }
        cancelButtonProps.value = {
          text: cancelTextParam,
          dataTestid: 'cancel-button',
        }
      },
    }

    const app = createApp({
      render() {
        return h(
          'div',
          {},
          [showModal.value
            ? h(ConfirmationModal, {
              modalProps: modalProps.value,
              confirmButtonProps: confirmButtonProps.value,
              cancelButtonProps: cancelButtonProps.value,
              content: content.value,
              onConfirm: async () => {
                confirmButtonProps.value.disabled = true
                await onConfirm.value()
                resetProps()
              },
              onCancel: () => {
                onCancel.value()
                resetProps()
              },
            })
            : null,
          ],
        )
      },
    })

    const confirmModalContainer = document.createElement('div')
    document.body.appendChild(confirmModalContainer)
    app.mount(confirmModalContainer)

    mainApp.config.globalProperties.$confirm = confirm
  },
}
